// Quantity validation utilities

export const validateQuantities = (locations) => {
  const errors = [];
  
  locations.forEach(loc => {
    if (loc.tpType) {
      const quantity = loc.quantity;
      const locationName = loc.number || loc.name || 'Unknown';
      
      if (quantity === undefined || quantity === null || quantity === '') {
        errors.push(`${locationName} (${loc.tpType}): Quantity is required`);
      } else {
        const numQuantity = Number(quantity);
        if (isNaN(numQuantity)) {
          errors.push(`${locationName} (${loc.tpType}): Invalid quantity "${quantity}" - must be a number`);
        } else if (numQuantity <= 0) {
          errors.push(`${locationName} (${loc.tpType}): Quantity must be positive (got ${numQuantity})`);
        } else if (!Number.isInteger(numQuantity)) {
          errors.push(`${locationName} (${loc.tpType}): Quantity must be a whole number (got ${numQuantity})`);
        }
      }
    }
  });
  
  return errors;
};
